import { Coins, LucideProps } from 'lucide-react';

type TProps = LucideProps & {
  className?: string;
};

export const IconCoins = ({ fill = '#fde047', size = 16, className }: TProps) => (
  <Coins
    fill={fill}
    size={size}
    className={`text-yellow-500 ${className}`} />
);

export default IconCoins;
